import BaseHttpService from "JS/services/BaseHttpService";

export class SearchAutocompleteService {
	constructor(private httpService: BaseHttpService) { }

	public async autocomplete(keyword?: string): Promise<SearchAutocompleteResult | null> {
		const url = new URL('/s/a/autocomplete', `${location.protocol}//${location.host}`);
		if (keyword?.trim()) {
			url.searchParams.set('keyword', keyword);
		}

		return await this.httpService.get<SearchAutocompleteResult | null>(url.toString());
	}
}

export default new SearchAutocompleteService(new BaseHttpService());

export interface SearchAutocompleteResultItem {
	url: string;
	html: string;
}

export interface SearchAutocompleteResultProduct {
	blainNumber: string;
	name: string;
	url: string;
	thumbnail: string;
	vendorBrand: string;
	isBestMatchVariant: boolean;
}

export interface SearchAutocompleteResult {
	productHeading: string;
	popularSearches: SearchAutocompleteResultItem[] | null;
	brands: SearchAutocompleteResultItem[] | null;
	categories: SearchAutocompleteResultItem[] | null;
	products: SearchAutocompleteResultProduct[] | null;
	count: number;
}